import { Location } from '@angular/common';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCarousel, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Pages } from 'src/infrastructure/labels/pages';
import { Successes } from 'src/infrastructure/labels/successes';
import { Favourite } from 'src/models/DTO/favourite/favourite';
import { Group } from 'src/models/DTO/groups/group';
import { GroupInfo } from 'src/models/DTO/groups/groupInfo';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { Price } from 'src/models/DTO/prices/price';
import { ProductTablePricing } from 'src/models/DTO/pricing/productTablePricing';
import { Product } from 'src/models/DTO/products/product';
import { createFavouriteRequestModel } from 'src/models/requestModels/favourites/createFavouriteRequestModel';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';
import { LocalstorageService } from 'src/services/core/localstorage/localstorage.service';
import { ToastService } from 'src/services/core/toast/toast.service';
import { UserService } from 'src/services/core/user/user.service';
import { FavouritesService } from 'src/services/request/favourites/favourites.service';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { ProductService } from 'src/services/request/product/product.service';
import { GroupStateService } from 'src/services/state/group/group-state.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';

@Component({
  selector: 'app-groupinfo',
  templateUrl: './groupinfo.component.html',
  styleUrls: ['./groupinfo.component.css']
})
export class GroupinfoComponent extends HistoryBaseComponent implements OnInit {

  private _selectedItemUUID? : string;
  private _filteredSizes: any[] = []
  private _selectedColorUUID = '';
  private _selectedSizeUUID = '';
  private _group?: GroupInfo;
  private _product?: Product;
  private _productImageCollection: ImageCollection = { data: [] };
  private _variationsImages: ImageCollection = { data: [] };
  private _usersImageCollection: { [key: string]: ImageCollection } = {};
  private _interval = interval(60000);
  private _pricing: Price[]  = [];
  private groupSecondsLeft: number = 0;
  private _favourites: Favourite = { data: []};


  public shouldShowBuyDialog = false;
  public goToMobileApp = '';


  @ViewChild('carouseltoggleGallery', { static: false })
  carouseltoggleGallery! :NgbCarousel

  @ViewChild('carouseltoggle')

  posIni: any;
  public clickedImageUUID = '';



  constructor(
    protected location: Location,
    protected historyService: HistoryService,
    private localstorageService: LocalstorageService,
    private userService: UserService,
    private groupService: GroupsService,
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private imagesService: ImagesService,
    private router: Router,
    private modalService: NgbModal,
    private ngZone: NgZone,
    private toast: ToastService,
    private favouriteService: FavouritesService,
    private groupStateService: GroupStateService,
    private orderStateService: OrederStateService
  ) {
    super(location, historyService);
    this._pageTitle = '';
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(urlParams => {
      this.groupService.getGroup(urlParams.uuid).subscribe(response => {
        this._group = response;
        this.getProductInfo(this._group.data.product_uuid);
        this.getImagesForProduct(this._group.data.product_uuid);
        this.startPossibleGroupTime();
        this.getImagesForUsers(this._group?.data.participants);
      }, error => {
        this.toast.warning("Групата е изтекла");
        this.router.navigate(["bottomtabs/home"])
      })
    });
    if (this.userService.isUserLogged()) {
      this.getFavourites();
    }
  }

  private getImagesForProduct(productUUID: string) {
    this.imagesService.getImagesForProduct("PRODUCT", productUUID).subscribe(response => {
      this._productImageCollection = response;
    })
  }

  private getImagesForUsers(participants: Array<any> = []) {
    participants.forEach(participant => {
      this.imagesService.getImagesForProduct("USER", participant.participant.uuid, 'logo').subscribe((response) => {
        participant.participant.imageURL = response.data[0]?.original.url || '/assets/images/account/account-image-not-found.svg'
      })
    });
  }

  private getProductInfo(productUUID: string) {
    this.productService.getProductInfo(productUUID).subscribe(response => {
      this._product = response;
      this._product.data.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from)
      this.getImagesForVariations();
    })
  }

  private joinGroup() {
    let createGroupModel: CreateGroupOrderRequestModel = {
      group_uuid: this._group!.data.uuid,
      sku: {
        uuid: this._selectedItemUUID || this._product?.data.skus[0].uuid || '' || '',
        quantity: 1
      },
      payment: {
        payment_method: undefined,
        method_uuid: null,
        user_stored_method_id: undefined,
        invoice_contact_uuid: undefined,
        invoice_contact_same_as_shipping: false,
        setup_user_method_for_future_usage: false
      },
      shipping: {
        method: '',
        carrier_office_id: undefined,
        contact_uuid: undefined,
        carrier_uuid: null
      },
      sum: this.getPricingFor(this._group!.data.quantity_reserved + 1),
      product: this._product!,
      quantity: this._group!.data.quantity_reserved
    }
    this.groupStateService.addNewOrderInfo(createGroupModel);
    this.orderStateService.addNewOrderInfo(
      {
        isNewAdrres: false,
        isNewPaymentMethod: false,
        isNewInvoiceAddress: false,
        toCarrierOffice: false,
        toAddress: true,
        personalInvoice: false,
        companyInvoice: false,
        cardPayment: true,
        cashPayment: false,
        checkedCartLines: []
      }
    );
      this.router.navigate(['group/join']);
  }

  private startPossibleGroupTime() {
    setInterval(() => {
      this.compareDates(this._group!.data.expires_at)
    }, 1000);
  }

  private filterSizes() {
    this.ngZone.run(() => {
      this._filteredSizes = [];
      let sizes = this._product?.data.skus[2]?.options.find(option => option.option.display_name == "Размер")?.option.values || [];
      if (!sizes.length) {
        this._product?.data.skus[2]?.options.forEach(option => {
          if (option.option.display_name == "Размер") {
            sizes.push({
              uuid: option.value,
              value: option.value
            });
          }
        })
      }
      let availableVariations = this.variations.filter(variation => {
        let filtered = false;
        variation.options.forEach(option => {
          if (option.option.display_name == "Цвят" && option.value == this._selectedColorUUID){
            filtered = true;
          }
        })
        return filtered;
      })
      sizes.forEach(size => {
        availableVariations.forEach(variation => {
          variation.options.forEach(option => {
            if (option.option.display_name == "Размер" && option.value == size.uuid) {
              console.log(this.filteredSizes)
              this.filteredSizes.push(size);
            }
          })
        })
      })
    })
  }

  private getImagesForVariations() {
    this.variations!.forEach(sku => {
      this.imagesService.getImagesForProduct("SKU", sku.uuid).subscribe(response => {
        sku.images = response;
        response.data?.forEach(image => {
            image.itemUUID = sku.uuid;
            this._variationsImages.data?.push(image);
          });
      })
    })
  }

  private updateTimeLeft() {
    if (this._group) {
      var diffMs = (new Date().getMilliseconds() - new Date(this._group.data.expires_at).getMilliseconds()); // milliseconds between now & Christmas
      var diffDays = Math.floor(diffMs / 86400000); // days
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
      var diffMins = Math.floor(((diffMs % 86400000) % 3600000) / 60000); // m
      var diffSec = Math.round((((diffMs % 86400000) % 3600000) % 60000) / 1000) ;
      this._group.data.expiration = {
        hours: diffHrs.toFixed(2) + ':',
        minutes: diffMins.toFixed(2) + ':',
        seconds: diffSec.toFixed(2)
      }
    }
  }

  private appendZerosToTime(value: number) {
    if (value < 10) {
      return '0' + value;
    }
    return value.toString();
  }

  private compareDates(start: string) {
    let parsedDate = start.split(/[- :]/);
    var startDate = new Date(parseInt(parsedDate[0]), parseInt(parsedDate[1])-1,
                             parseInt(parsedDate[2]), parseInt(parsedDate[3]),
                             parseInt(parsedDate[4]), parseInt(parsedDate[5]));
    // Do your operations
    var endDate   = new Date().toLocaleString("en-US", {timeZone: "Europe/Sofia"});
    var seconds = (startDate.getTime() - new Date(endDate).getTime()) / 1000;
    this.groupSecondsLeft = seconds;
    if (this.groupSecondsLeft < 0) {
      this.toast.info("Групата е изтекла");
      this.router.navigate(["bottomtabs/home"])
    }

  }

  private checkIfProductIsWellSelectedBeforeCart() {
    if (this.colors.length && this._selectedColorUUID && this.sizes.length && this._selectedSizeUUID ) return true;
    if (this.colors.length && this._selectedColorUUID && !this.sizes.length) return true;
    if (!this.colors.length && this.sizes.length && this._selectedSizeUUID ) return true;
    return false;
  }

  private getFavourites() {
    this.favouriteService.getFavourites().subscribe((favourites) => {
      if (favourites) {
        this._favourites = favourites
      }
      else {
        this._favourites = { data: [] };
      }
    })
  }

  get nextPercent() {
    return this.calculateDiscount(this.getPricingFor(1), this.getPricingFor((this._group?.data.quantity_reserved || 0) + 1)).replace('-', '');
  }

  get selectedItemUUID() {
    return this._selectedItemUUID;
  }


  get selectedColor() {
    if (this._selectedItemUUID) {
      let color = '';
      let variation = this.variations.find(variation => variation.uuid == this._selectedItemUUID);
      let colors = variation?.options.find(option => option.option.display_name == "Цвят")?.option?.values || '';
      if (!colors.length) {
        color = variation?.options.find(option => option.option.display_name == "Цвят")?.value || '';
        this._selectedColorUUID = color;
      }
      else {
        let colorUUID = variation?.options.find(option => option.option.display_name == "Цвят")?.value || '';
        color = this.colors.find(color => color.uuid == colorUUID)?.value || '';
        this._selectedColorUUID = colorUUID;

      }
      this.filterSizes()
      return color;
    }
    return '';
  }

  get selectedSizeUUID() {
    return this._selectedSizeUUID;
  }

  get selectedColorUUID() {
    return this._selectedColorUUID;
  }

  get variations() {
    return this._product?.data.skus.slice(1) || [];
  }

  get colors() {
    let colors =  this._product?.data.skus[2]?.options.find(option => option.option.display_name == "Цвят")?.option.values || [];
    if (!colors.length) {
      this._product?.data.skus[2]?.options.forEach(option => {
        if (option.option.display_name == "Цвят") {
          colors.push({
            uuid: option.value,
            value: option.value
          });
        }
      })
    }
    return colors || [];
  }

  get sizes() {
    let sizes = this._product?.data.skus[2]?.options.find(option => option.option.display_name == "Размер")?.option.values || [];
    if (!sizes.length) {
      this._product?.data.skus[2]?.options.forEach(option => {
        if (option.option.display_name == "Размер") {
          sizes.push({
            uuid: option.value,
            value: option.value
          });
        }
      })
    }
    let availableSizes: any[] = [];
    sizes.forEach(size => {
      this.variations.forEach(variation => {
        variation.options.forEach(option => {
          if (option.option.display_name == "Размер" && option.value == size.uuid) {
            availableSizes.push(size);
          }
        })
      })
    })
    return availableSizes;
  }

  get filteredSizes() {
    return this._filteredSizes;
  }

  get filteredVariations() {
    let availableVariations = this._product?.data.skus.slice(1);
    let returnVariations = this._product?.data.skus.slice(1).filter(vari => false) || [];
    availableVariations?.forEach((variation, index, self) => {
      let status = true;
      let tmpColor = variation.options.find(option => option.option.display_name == "Цвят")?.value;
      returnVariations.forEach(tmpVar => {
        tmpVar.options.forEach(tmpOpt => {
          if (tmpOpt.option.display_name == "Цвят" && tmpOpt.value == tmpColor) {
            status = false;
          }
        })
      })
      if (status) {
        returnVariations.push(variation);
      }
    })
    return returnVariations;
  }

  get groupTime() {
    if (this.groupSecondsLeft) {
      let seconds = Math.ceil(this.groupSecondsLeft);
      // 2- Extract hours:
      const hours = Math.floor( seconds / 3600 ); // 3,600 seconds in 1 hour
      seconds = seconds % 3600; // seconds remaining after extracting hours
      // 3- Extract minutes:
      const minutes = Math.floor( seconds / 60 ); // 60 seconds in 1 minute
      // 4- Keep only seconds not extracted to minutes:
      seconds = seconds % 60;
      return this.appendZerosToTime(hours) + ":" + this.appendZerosToTime(minutes) + ":" + this.appendZerosToTime(seconds)
    }
    else return ''
  }

  get timeLeft() {
    return (this._group?.data.expiration?.hours || '' + this._group?.data.expiration?.minutes || '' + this._group?.data.expiration?.seconds) || '';
  }

  get product() {
    return this._product?.data;
  }

  get productImages(): ImageCollection {
    if (this._selectedItemUUID) {
      return this.variations.find(variation => variation.uuid == this._selectedItemUUID)?.images || { data: [] };
    }
    return this._productImageCollection.data?.length
      ? this._productImageCollection
      : { data: [{ original: { url: Config.defaultImage } }] };
  }

  get group() {
    return this._group;
  }

  get userImages() {
    return this._usersImageCollection;
  }

  get pricing() {
    return this.product?.pricing[0].price_per_piece || '00:00';
  }

  get discountedPrice() {
    return Number.parseFloat(this.getPricingFor((this._group?.data.quantity_reserved || 0) + 1))
  }

  get currentPricing() : Price[] {
    return this._pricing;
  }

  getStandardUnitPriceBase(): number {
    return Number(this.pricing) || 0;
  }

  getDiscountedUnitPriceBase(): number {
    return Number(this.discountedPrice) || 0;
  }

  getPricingAmountBase(amount: string | undefined): number {
    return Number(amount) || 0;
  }

  getFreeDeliveryThresholdBase(): number {
    return Number(this.product?.organisation?.free_delivery_after_order_amount) || 0;
  }

  getCourierOfficeDeliveryBase(): number {
    return Number(this.product?.organisation?.delivery_to_courier_office_price) || 0;
  }

  getAddressDeliveryBase(): number {
    return Number(this.product?.organisation?.delivery_to_address_price) || 0;
  }

  get maxAmountForPricing() {
    return this._product?.data.pricing[this._product?.data.pricing.length - 1].quantity_to.toString() || '';
  }

  get minPriceForPricing() {
    return this._product?.data.pricing[this._product?.data.pricing.length - 1].price_per_piece.toString() || '';
  }

  public variationImageURL(itemUUID: string)  {
    const currentVariationImage = this._variationsImages.data?.find(image => image.itemUUID == itemUUID);
    return (currentVariationImage) ? currentVariationImage.original.url : Config.defaultImage;
  }

  public selectSize(sizeUUID: string) {
    this._selectedSizeUUID = sizeUUID;
  }

  get isFavourite() : boolean {
    return (this._favourites.data.length > 0) && (this._favourites.data.findIndex(favourite => favourite.uuid  == this._product?.data?.uuid) > -1);
  }

  public back(): void {
    if (this.historyService.historyList.length < 2 || !this.historyService.historyList[this.historyService.historyList.length - 2].includes('product/')) {
      this.router.navigate(["bottomtabs/groups"])
    }
    else {
      super.back();
    }
  }

  registration(currentModal: any) {
    this.localstorageService.setLocalStorageItem(Config.goToRouteLSKey, window.location.href.split(/(?:com|4200)\/(.*)/s)[1])
    currentModal.close();
    this.router.navigate(['registration']);
  }

  goToGooglePlay(){
    window.location.href = this.goToMobileApp;
  }

  loginNavigation(currentModal: any) {
    this.localstorageService.setLocalStorageItem(Config.goToRouteLSKey, window.location.href.split(/(?:com|4200)\/(.*)/s)[1])
    currentModal.close();
    this.router.navigate(['login']);
  }

  getPricingAsString(pricing: string) {
    let priceArray = pricing.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    priceArray.push(Pages.bg.shared.currency);
    return priceArray;
  }

  getPricingAsStringFromNumber(pricing: number) {
    return this.getPricingAsString(pricing.toFixed(2))
  }

  // share(): void {
  //   const currentUrl = window.location.href;
  //   const shareUrl = `${window.location.origin}/redirect?target=${encodeURIComponent(currentUrl)}`;
  //
  //   if (navigator.share) {
  //     navigator.share({ url: shareUrl }).catch(() => {});
  //     return;
  //   }
  //
  //   navigator.clipboard?.writeText(shareUrl).catch(() => {});
  // }

  share(): void {
    const currentUrl = window.location.href;
    const baseWeb = window.location.origin;
    const title = this.product?.name || 'Групова поръчка в ShareMe';
    const imageUrl = this.getShareImageUrl();

    const params = new URLSearchParams();
    params.set('target', currentUrl);
    params.set('title', title);

    if (imageUrl) {
      params.set('image', imageUrl);
    }

    const shareUrl = `${baseWeb}/redirect?${params.toString()}`;

    if (navigator.share) {
      navigator.share({
        title,
        url: shareUrl
      }).catch(() => {});
      return;
    }

    navigator.clipboard?.writeText(shareUrl).catch(() => {});
  }

  private getShareImageUrl(): string {
    const imageUrl = this.productImages.data.length
      ? this.productImages.data[0].original.url
      : Config.defaultImage;

    return this.toAbsoluteUrl(imageUrl);
  }

  private toAbsoluteUrl(url: string): string {
    if (!url) { return ''; }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    return `${window.location.origin}${url.charAt(0) === '/' ? '' : '/'}${url}`;
  }

  join(loginModal: any) {
    if (!this.userService.isUserLogged()) {
      this.modalService.open(loginModal, { size: 'sm',  windowClass: 'loginModal' })
      return;
    }
    if (!this.checkIfProductIsWellSelectedBeforeCart() && this.variations.length) {
      this.toast.info("Не сте избрали цвят или размер");
      return;
    }
    this.joinGroup();
  }

  selectItem(uuid: string) {
    this._selectedColorUUID = '';
    this._selectedSizeUUID = '';
    this._selectedItemUUID = uuid;
    this.shouldShowBuyDialog = true;
  }

  getActiveIdForImageCarousel() {
    return this.productImages.data.findIndex(image => image.uuid == this.clickedImageUUID).toString()
  }

  move(pos:number, carouselToMove: any) {
    const offset = this.posIni - pos;
    if (offset < -100) {
      carouselToMove.prev();
    }
    if (offset > 100) {
      carouselToMove.next();
    }
  }

  onImageClick(imageModal: any, carouseltoggleGallery: any, image: any) {
    this.clickedImageUUID = image.uuid;
    this.carouseltoggleGallery = carouseltoggleGallery;
    let test = this.modalService.open(imageModal, { size: 'sm',  windowClass: 'imageCaorusel' })
  }

  getPricingPerAmount(pricing: string) {
    return pricing + Pages.bg.shared.valuePerStock;
  }

  calculateDiscount(pricingFrom : string, pricingTo : string) {
    const pricing = Number.parseFloat(pricingFrom);
    const priceToConvertion = Number.parseFloat(pricingTo);
    const discount = pricing - priceToConvertion;
    return '-' + Math.round((discount/pricing)*100) + '%';
  }


  toggleFavourite() {

    const createFavouriteModel : createFavouriteRequestModel = {
      product_uuid: this._product?.data?.uuid || '',
    }
    if (this.isFavourite) {
      this.favouriteService.removeFavourite(createFavouriteModel).subscribe(() => {
        this.getFavourites();
        this.toast.success(Successes.bg.unfavourite)
      })
    }
    else {
      this.favouriteService.generateFavourite(createFavouriteModel).subscribe(() => {
        this.getFavourites();
        this.toast.success(Successes.bg.favourite)
      })
    }
  }

  goToProduct(productUUID: string) {
    this.router.navigate(['product/' + productUUID + '/' + 'none'])
  }

  getPricingFor(qty: number) : string {
    if (!this._product) return '0.00';
    let pricing = this._product?.data?.pricing.find((price) => {
      return price.quantity_from <= qty && price.quantity_to >= qty
    });
    if (this._product) {
      if (!pricing) {
        pricing = this._product!.data.pricing[this._product!.data.pricing.length - 1];
      }
      if (!pricing) {
        pricing = this._product!.data.pricing[0];
      }
    }

    return pricing?.price_per_piece || '0.00';
  }

  deliveryPricingLabel(fee: string | undefined) {
    return fee + Pages.bg.shared.currency;
  }

  getAmountLabels(amount: number) {
    return amount + Pages.bg.shared.stock;
  }

  getFullAmountLabel(amount: number) {
    let stock = Pages.bg.shared.fullStocks;
    if (amount == 1) {
      stock = Pages.bg.shared.fullStock;
    }
    return amount + stock;
  }

  getAmountLabel(pricing: ProductTablePricing) {
    let stock = Pages.bg.shared.fullStocks;
    if (pricing.quantity_from == 1) {
      stock = Pages.bg.shared.fullStock;
    }
    if (pricing.quantity_to != pricing.quantity_from) {
      return pricing.quantity_from;
    }
    return pricing.quantity_from + stock;
  }

}
